var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoflechitaarribaDorada(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.307,
    height: 8.752,
    viewBox: "0 0 15.307 8.752",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-up",
    "data-name": "Icon ionic-ios-arrow-up",
    d: "M13.843,13.889l5.787,5.792a1.094,1.094,0,0,0,1.545-1.549l-6.558-6.562a1.092,1.092,0,0,0-1.508-.032l-6.6,6.59a1.094,1.094,0,0,0,1.545,1.549Z",
    transform: "translate(-6.188 -11.251)",
    fill: "#b2a169"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoflechitaarribaDorada);
export default __webpack_public_path__ + "static/media/Icono flechita arriba - dorada.f455295d85a6d6df37983f2dc84de1ec.svg";
export { ForwardRef as ReactComponent };